import apiConfig from "../utils/api-config";

const MovieCard = ({ title, release_date, poster_path, popularity }) => (
    <div
        className="flex flex-col rounded-md p-4 font-bold bg-zinc-900 
                    w-full md:w-11/12 h-full shadow-lg cursor-pointer 
                    hover:-translate-y-2 transition 0.3s ease-in-out"
    >
        <img
            className="w-full rounded-lg"
            src={apiConfig.getImage(poster_path)}
            alt={title}
            loading="lazy"
        />

        <div className="flex flex-col justify-between mt-2 space-y-2">
            <h2 className="text-xl truncate">{title}</h2>
            <div className="flex justify-between w-full font-thin">
                <p>{release_date}</p>
                <p>Popularity: {popularity}</p>
            </div>
        </div>
    </div>
);

export default MovieCard;
